import { render, staticRenderFns } from "./newComManagementScript.vue?vue&type=template&id=721eccb6&scoped=true"
import script from "./newComManagementScript.vue?vue&type=script&lang=js"
export * from "./newComManagementScript.vue?vue&type=script&lang=js"
import style0 from "./newComManagementScript.vue?vue&type=style&index=0&id=721eccb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "721eccb6",
  null
  
)

export default component.exports